import type { PartialDeep } from 'type-fest';
import { Configuration } from '../defaultConfig';
// eslint-disable-next-line camelcase
import preprod_e2e from './preprod_e2e';
import e2e from './e2e';
import mock from './mock';
import dev from './dev';
import preprod from './preprod';
import prod from './prod';

const stageConfig: Record<string, PartialDeep<Configuration>> = {
  mock,
  e2e,
  // eslint-disable-next-line camelcase
  preprod_e2e,
  dev,
  preprod,
  prod,
};

export default stageConfig;
